import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";
export default class AbhacreationAN extends Component {
  constructor(props) {
    super(props);
     this.state = {
      requestId: sessionStorage.getItem("requestId"),
      abhaAddress: sessionStorage.getItem("abhaaddress"),
      isValid: null,
      isAvailable: null,
      suggestions: [],
      isSubmitting: false,
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };
  componentDidMount() {
    this.ResponseHandler();
    this.Handleabhachange();
  }
  ResponseHandler = () => {
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhaverify/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail  && data.detail.abhaprofile) {
          const profile = data.detail;
  
          if (profile?.phrAddress) {
            this.setState({ AbhaProfile: { phrAddress: profile.phrAddress } });
          }
          // Or fallback to parsing abhaprofile string
          else if (profile.abhaprofile) {
            try {
              const abhaDetails = JSON.parse(profile.abhaprofile);
              const abhaProfile = abhaDetails?.ABHAProfile;
              if (abhaProfile) {
                this.setState({ AbhaProfile: abhaProfile });
              }
            } catch (err) {
              console.error("Failed to parse abhaprofile JSON:", err);
              toast.error("Invalid ABHA profile data");
            }
          } else {
            console.warn("No ABHA profile or phrAddress in response.");
          }
        }
      });
  };
  
  Handleabhachange = (e) => {
    const { requestId } = this.state;

    const formData = new FormData();
    formData.append("abhaAddress", sessionStorage.abhaAddress);
    formData.append("requestId", requestId);

    fetch(configData.api_url + "C_Abhaverify/getSuggetionsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" && data?.isAvailable) {
          toast.success("ABHA address is available");
          this.setState({ isAvailable: true, suggestions: [] });
        } else {
         
             this.showToast(data.message||"Invalid Transaction Id")
          this.setState({
            isAvailable: false,
            suggestions: data.abhaDetails?.abhaAddressList || [],
          });
        }
      })
      .catch(() => toast.error("Error checking ABHA address availability"));
  };

  validateAbhaAddress = (input) => {
    const minLength = 8;
    const maxLength = 18;
    const regex = /^[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*$/;

    const startsOrEndsWithSpecial = /^[._]|[._]$/.test(input);
    const dotCount = (input.match(/\./g) || []).length;
    const underscoreCount = (input.match(/_/g) || []).length;

    return (
      input.length >= minLength &&
      input.length <= maxLength &&
      regex.test(input) &&
      !startsOrEndsWithSpecial &&
      dotCount <= 1 &&
      underscoreCount <= 1
    );
  };


  handleAbhaBlur = () => {
    const { isValid, requestId, abhaAddress } = this.state;
    if (!isValid) {
      this.showToast("Invalid ABHA Address format. Please follow the rules.");
      return;
    }

    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("requestId", requestId);

    fetch(configData.api_url + "C_Abhaverify/getSuggetionsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" && data?.isAvailable) {
          toast.success("ABHA address is available");
          this.setState({ isAvailable: true, suggestions: [] });
        } else {
          toast.error("ABHA address is already taken");
          this.setState({
            isAvailable: false,
            suggestions: data.abhaDetails?.abhaAddressList || [],
          });
        }
      })
      .catch(() => toast.error("Error checking ABHA address availability"));
  };

  handleSuggestionClick = (suggestion) => {
    const isValid = this.validateAbhaAddress(suggestion);
    this.setState({
      abhaAddress: suggestion,
      isValid,
      isAvailable: null,
      suggestions: [],
      abhaDetails: {},
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { abhaAddress } = this.state;

    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("requestId", this.state.requestId);
    this.setState({ isSubmitting: true });

    fetch(configData.api_url + "C_Abhaverify/setnewabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.setState({ isSubmitting: false });
      });
  };
  handlenextClick = () => {
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/getAbhaProfile", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem(
          "abhaAddress",
          this.state.AbhaProfile.phrAddress
        );

        this.showToast(data.message);

        if (data.status === "success") {
          window.location.href = "/abhanumberprofile";
        }
      });
  };
  render() {
    const { isValid, abhaAddress, suggestions } = this.state;
    return (
      <div>
        <div className="row justify-content-md-center text-center abhaAddressChange">
        <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
          ABHA Address Update / Creation
        </h3>
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>ABHA Address Creation</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control
                    type="text"
                    value={abhaAddress}
                    onChange={this.handleAbhaChange}
                    onBlur={this.handleAbhaBlur}
                    onKeyDown={this.onKeyDown}
                    className={`form-control ${
                      abhaAddress ? (isValid ? "is-valid" : "is-invalid") : ""
                    }`}
                  />
                </div>
                <Form>
                  <p>
                    Current ABHA Address:
                    <strong> {sessionStorage.abhaAddress}</strong>
                  </p>
                </Form>
       
                  <div className="mt-2">
                    <div className="d-flex flex-wrap mt-1">
                      {suggestions.length > 0 && (
                        <div className="mt-2">
                          <strong>Suggestions:</strong>
                          <div className="d-flex flex-wrap mt-1">
                            {suggestions.map((s, i) => (
                              <span
                                key={i}
                                className="badge bg-secondary me-2 mb-2"
                                onClick={() => this.handleSuggestionClick(s)}
                                style={{ cursor: "pointer" }}
                              >
                                {s}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
             
              </Form.Group>
              <Button className="rounded-0 m-1" onClick={this.handleSubmit}>
                New ABHA Address
              </Button>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
            <Button className="rounded-0 m-1" onClick={this.handlenextClick}>
              Next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
